var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('img',{staticClass:"fotoa",attrs:{"src":"foto_Architetti.jpg"}}),(_vm.lang=='it')?_c('about-it'):_vm._e(),(_vm.lang=='en')?_c('about-en'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }